/**
 * @generated SignedSource<<a84ff5a172ec9e6565c794819e7a95bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type GetPortfolioPerformanceInput = {
  financialAccountIds: ReadonlyArray<number>;
};
export type PortfolioPerformanceModelFilterInput = {
  accountDefaultName?: StringOperationFilterInput | null;
  accountId?: ComparableInt32OperationFilterInput | null;
  and?: ReadonlyArray<PortfolioPerformanceModelFilterInput> | null;
  asOfDate?: ComparableNullableOfDateOnlyOperationFilterInput | null;
  custodian?: StringOperationFilterInput | null;
  fiveYearReturns?: ComparableNullableOfDoubleOperationFilterInput | null;
  inceptionDate?: ComparableNullableOfDateOnlyOperationFilterInput | null;
  managementStyle?: StringOperationFilterInput | null;
  marketValue?: ComparableNullableOfDoubleOperationFilterInput | null;
  monthToDate?: ComparableNullableOfDoubleOperationFilterInput | null;
  netGross?: StringOperationFilterInput | null;
  oneYearReturns?: ComparableNullableOfDoubleOperationFilterInput | null;
  or?: ReadonlyArray<PortfolioPerformanceModelFilterInput> | null;
  portfolioPerformanceId?: ComparableInt32OperationFilterInput | null;
  quarterToDate?: ComparableNullableOfDoubleOperationFilterInput | null;
  sinceInception?: ComparableNullableOfDoubleOperationFilterInput | null;
  tenYearReturns?: ComparableNullableOfDoubleOperationFilterInput | null;
  threeYearReturns?: ComparableNullableOfDoubleOperationFilterInput | null;
  yearToDate?: ComparableNullableOfDoubleOperationFilterInput | null;
};
export type ComparableInt32OperationFilterInput = {
  eq?: number | null;
  gt?: number | null;
  gte?: number | null;
  in?: ReadonlyArray<number> | null;
  lt?: number | null;
  lte?: number | null;
  neq?: number | null;
  ngt?: number | null;
  ngte?: number | null;
  nin?: ReadonlyArray<number> | null;
  nlt?: number | null;
  nlte?: number | null;
};
export type StringOperationFilterInput = {
  and?: ReadonlyArray<StringOperationFilterInput> | null;
  contains?: string | null;
  endsWith?: string | null;
  eq?: string | null;
  in?: ReadonlyArray<string | null> | null;
  ncontains?: string | null;
  nendsWith?: string | null;
  neq?: string | null;
  nin?: ReadonlyArray<string | null> | null;
  nstartsWith?: string | null;
  or?: ReadonlyArray<StringOperationFilterInput> | null;
  startsWith?: string | null;
};
export type ComparableNullableOfDoubleOperationFilterInput = {
  eq?: number | null;
  gt?: number | null;
  gte?: number | null;
  in?: ReadonlyArray<number | null> | null;
  lt?: number | null;
  lte?: number | null;
  neq?: number | null;
  ngt?: number | null;
  ngte?: number | null;
  nin?: ReadonlyArray<number | null> | null;
  nlt?: number | null;
  nlte?: number | null;
};
export type ComparableNullableOfDateOnlyOperationFilterInput = {
  eq?: any | null;
  gt?: any | null;
  gte?: any | null;
  in?: ReadonlyArray<any | null> | null;
  lt?: any | null;
  lte?: any | null;
  neq?: any | null;
  ngt?: any | null;
  ngte?: any | null;
  nin?: ReadonlyArray<any | null> | null;
  nlt?: any | null;
  nlte?: any | null;
};
export type PerformanceQueryReaderQuery$variables = {
  performanceInput: GetPortfolioPerformanceInput;
  performanceModelFilterInput?: PortfolioPerformanceModelFilterInput | null;
};
export type PerformanceQueryReaderQuery$data = {
  readonly clientsummary_viewer: {
    readonly financialAccounts: ReadonlyArray<{
      readonly accountName: string;
      readonly accountNumber: string;
      readonly accountType: string;
      readonly accountTypeAbbreviation: string;
      readonly clientIdentifier: any;
      readonly custodian: string;
      readonly id: string;
      readonly managementStyle: string;
      readonly registrationName: string;
    }>;
    readonly getPerformanceByAccountGroup: ReadonlyArray<{
      readonly accountGroupId: string;
      readonly asOfDate: any | null;
      readonly fiveYearReturns: number | null;
      readonly inceptionDate: any | null;
      readonly marketValue: number | null;
      readonly monthToDate: number | null;
      readonly oneYearReturns: number | null;
      readonly performanceByAccountGroupId: number;
      readonly quarterToDate: number | null;
      readonly sinceInception: number | null;
      readonly tenYearReturns: number | null;
      readonly threeYearReturns: number | null;
      readonly yearToDate: number | null;
    }>;
    readonly getPerformanceByAssetClassForAssetValue: ReadonlyArray<{
      readonly asOfDate: any | null;
      readonly assetClassName: string | null;
      readonly fiveYearReturns: number | null;
      readonly householdName: string | null;
      readonly inceptionDate: any | null;
      readonly marketValue: number | null;
      readonly monthToDate: number | null;
      readonly oneYearReturns: number | null;
      readonly performanceByAssetClassForAssetValueId: number;
      readonly quarterToDate: number | null;
      readonly sinceInception: number | null;
      readonly tenYearReturns: number | null;
      readonly threeYearReturns: number | null;
      readonly yearToDate: number | null;
    }>;
    readonly getPerformanceByHoldingsForAccountValue: ReadonlyArray<{
      readonly accountId: number;
      readonly accountName: string | null;
      readonly asOfDate: any | null;
      readonly fiveYearReturns: number | null;
      readonly householdName: string | null;
      readonly inceptionDate: any | null;
      readonly marketValue: number | null;
      readonly monthToDate: number | null;
      readonly oneYearReturns: number | null;
      readonly performanceByHoldingsForAccountValueId: number;
      readonly productName: string;
      readonly quarterToDate: number | null;
      readonly sinceInception: number | null;
      readonly tenYearReturns: number | null;
      readonly threeYearReturns: number | null;
      readonly yearToDate: number | null;
    }>;
    readonly getPerformanceByHousehold: ReadonlyArray<{
      readonly asOfDate: any | null;
      readonly fiveYearReturns: number | null;
      readonly householdName: string | null;
      readonly inceptionDate: any | null;
      readonly marketValue: number | null;
      readonly monthToDate: number | null;
      readonly oneYearReturns: number | null;
      readonly performanceByHouseholdId: number;
      readonly quarterToDate: number | null;
      readonly sinceInception: number | null;
      readonly tenYearReturns: number | null;
      readonly threeYearReturns: number | null;
      readonly yearToDate: number | null;
    }>;
    readonly getPerformanceByManagementStyle: ReadonlyArray<{
      readonly asOfDate: any | null;
      readonly fiveYearReturns: number | null;
      readonly householdName: string | null;
      readonly inceptionDate: any | null;
      readonly managementStyle: string;
      readonly marketValue: number | null;
      readonly monthToDate: number | null;
      readonly oneYearReturns: number | null;
      readonly performanceByManagementStyleId: number;
      readonly quarterToDate: number | null;
      readonly sinceInception: number | null;
      readonly tenYearReturns: number | null;
      readonly threeYearReturns: number | null;
      readonly yearToDate: number | null;
    }>;
    readonly getPerformanceByProduct: ReadonlyArray<{
      readonly asOfDate: any | null;
      readonly assetClassName: string;
      readonly fiveYearReturns: number | null;
      readonly householdName: string;
      readonly inceptionDate: any | null;
      readonly marketValue: number | null;
      readonly monthToDate: number | null;
      readonly oneYearReturns: number | null;
      readonly performanceByProductId: number;
      readonly productName: string;
      readonly quarterToDate: number | null;
      readonly sinceInception: number | null;
      readonly subAssetClassName: string;
      readonly tenYearReturns: number | null;
      readonly threeYearReturns: number | null;
      readonly yearToDate: number | null;
    }>;
    readonly getPerformanceBySubAssetClassForSubAssetValue: ReadonlyArray<{
      readonly asOfDate: any | null;
      readonly fiveYearReturns: number | null;
      readonly householdName: string | null;
      readonly inceptionDate: any | null;
      readonly marketValue: number | null;
      readonly monthToDate: number | null;
      readonly oneYearReturns: number | null;
      readonly performanceBySubAssetClassForSubAssetValueId: number;
      readonly quarterToDate: number | null;
      readonly sinceInception: number | null;
      readonly subAssetClassName: string | null;
      readonly tenYearReturns: number | null;
      readonly threeYearReturns: number | null;
      readonly yearToDate: number | null;
    }>;
    readonly getPortfolioPerformance: ReadonlyArray<{
      readonly accountDefaultName: string;
      readonly accountId: number;
      readonly asOfDate: any | null;
      readonly custodian: string | null;
      readonly fiveYearReturns: number | null;
      readonly inceptionDate: any | null;
      readonly managementStyle: string;
      readonly marketValue: number | null;
      readonly monthToDate: number | null;
      readonly netGross: string | null;
      readonly oneYearReturns: number | null;
      readonly portfolioPerformanceId: number;
      readonly quarterToDate: number | null;
      readonly sinceInception: number | null;
      readonly tenYearReturns: number | null;
      readonly threeYearReturns: number | null;
      readonly yearToDate: number | null;
    }>;
    readonly id: string;
  };
  readonly userprofile_viewer: {
    readonly accountGroups: ReadonlyArray<{
      readonly accounts: ReadonlyArray<{
        readonly financialAccountId: number;
        readonly id: any;
      }>;
      readonly id: string;
      readonly name: string;
    }>;
    readonly accounts: ReadonlyArray<{
      readonly accountNickname: string;
      readonly financialAccountId: number;
    }>;
    readonly id: string;
  } | null;
};
export type PerformanceQueryReaderQuery = {
  response: PerformanceQueryReaderQuery$data;
  variables: PerformanceQueryReaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "performanceInput"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "performanceModelFilterInput"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "financialAccountId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "asOfDate",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "marketValue",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "monthToDate",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quarterToDate",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "yearToDate",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oneYearReturns",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "threeYearReturns",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fiveYearReturns",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tenYearReturns",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sinceInception",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "inceptionDate",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "householdName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "custodian",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "managementStyle",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetClassName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subAssetClassName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productName",
  "storageKey": null
},
v22 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserProfileViewer",
    "kind": "LinkedField",
    "name": "userprofile_viewer",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "UserAccount",
        "kind": "LinkedField",
        "name": "accounts",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountNickname",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountGroup",
        "kind": "LinkedField",
        "name": "accountGroups",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "accounts",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ClientSummaryViewer",
    "kind": "LinkedField",
    "name": "clientsummary_viewer",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "PerformanceByHouseholdModel",
        "kind": "LinkedField",
        "name": "getPerformanceByHousehold",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "performanceByHouseholdId",
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "performanceInput"
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "performanceModelFilterInput"
          }
        ],
        "concreteType": "PortfolioPerformanceModel",
        "kind": "LinkedField",
        "name": "getPortfolioPerformance",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountDefaultName",
            "storageKey": null
          },
          (v15/*: any*/),
          (v3/*: any*/),
          (v16/*: any*/),
          (v10/*: any*/),
          (v13/*: any*/),
          (v17/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "netGross",
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "portfolioPerformanceId",
            "storageKey": null
          },
          (v6/*: any*/),
          (v12/*: any*/),
          (v11/*: any*/),
          (v9/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PerformanceByAccountGroupModel",
        "kind": "LinkedField",
        "name": "getPerformanceByAccountGroup",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "performanceByAccountGroupId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountGroupId",
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PerformanceByAssetClassForAssetValueModel",
        "kind": "LinkedField",
        "name": "getPerformanceByAssetClassForAssetValue",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "performanceByAssetClassForAssetValueId",
            "storageKey": null
          },
          (v3/*: any*/),
          (v18/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PerformanceBySubAssetClassForSubAssetValueModel",
        "kind": "LinkedField",
        "name": "getPerformanceBySubAssetClassForSubAssetValue",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "performanceBySubAssetClassForSubAssetValueId",
            "storageKey": null
          },
          (v3/*: any*/),
          (v19/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PerformanceByHoldingsForAccountValueModel",
        "kind": "LinkedField",
        "name": "getPerformanceByHoldingsForAccountValue",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "performanceByHoldingsForAccountValueId",
            "storageKey": null
          },
          (v3/*: any*/),
          (v15/*: any*/),
          (v20/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v21/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PerformanceByManagementStyleModel",
        "kind": "LinkedField",
        "name": "getPerformanceByManagementStyle",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "performanceByManagementStyleId",
            "storageKey": null
          },
          (v3/*: any*/),
          (v17/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PerformanceByProductModel",
        "kind": "LinkedField",
        "name": "getPerformanceByProduct",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "performanceByProductId",
            "storageKey": null
          },
          (v14/*: any*/),
          (v21/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v3/*: any*/),
          (v13/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FinancialAccount",
        "kind": "LinkedField",
        "name": "financialAccounts",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v20/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientIdentifier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "registrationName",
            "storageKey": null
          },
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountTypeAbbreviation",
            "storageKey": null
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PerformanceQueryReaderQuery",
    "selections": (v22/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PerformanceQueryReaderQuery",
    "selections": (v22/*: any*/)
  },
  "params": {
    "cacheID": "b1adf1f491eea107859cb22125fbd9ff",
    "id": null,
    "metadata": {},
    "name": "PerformanceQueryReaderQuery",
    "operationKind": "query",
    "text": "query PerformanceQueryReaderQuery(\n  $performanceInput: GetPortfolioPerformanceInput!\n  $performanceModelFilterInput: PortfolioPerformanceModelFilterInput\n) {\n  userprofile_viewer {\n    id\n    accounts {\n      accountNickname\n      financialAccountId\n    }\n    accountGroups {\n      id\n      name\n      accounts {\n        id\n        financialAccountId\n      }\n    }\n  }\n  clientsummary_viewer {\n    id\n    getPerformanceByHousehold {\n      performanceByHouseholdId\n      asOfDate\n      marketValue\n      monthToDate\n      quarterToDate\n      yearToDate\n      oneYearReturns\n      threeYearReturns\n      fiveYearReturns\n      tenYearReturns\n      sinceInception\n      inceptionDate\n      householdName\n    }\n    getPortfolioPerformance(input: $performanceInput, where: $performanceModelFilterInput) {\n      accountDefaultName\n      accountId\n      asOfDate\n      custodian\n      fiveYearReturns\n      inceptionDate\n      managementStyle\n      marketValue\n      monthToDate\n      netGross\n      oneYearReturns\n      portfolioPerformanceId\n      quarterToDate\n      sinceInception\n      tenYearReturns\n      threeYearReturns\n      yearToDate\n    }\n    getPerformanceByAccountGroup {\n      performanceByAccountGroupId\n      accountGroupId\n      asOfDate\n      marketValue\n      monthToDate\n      quarterToDate\n      yearToDate\n      oneYearReturns\n      threeYearReturns\n      fiveYearReturns\n      tenYearReturns\n      sinceInception\n      inceptionDate\n    }\n    getPerformanceByAssetClassForAssetValue {\n      performanceByAssetClassForAssetValueId\n      asOfDate\n      assetClassName\n      marketValue\n      monthToDate\n      quarterToDate\n      yearToDate\n      oneYearReturns\n      threeYearReturns\n      fiveYearReturns\n      tenYearReturns\n      sinceInception\n      inceptionDate\n      householdName\n    }\n    getPerformanceBySubAssetClassForSubAssetValue {\n      performanceBySubAssetClassForSubAssetValueId\n      asOfDate\n      subAssetClassName\n      marketValue\n      monthToDate\n      quarterToDate\n      yearToDate\n      oneYearReturns\n      threeYearReturns\n      fiveYearReturns\n      tenYearReturns\n      sinceInception\n      inceptionDate\n      householdName\n    }\n    getPerformanceByHoldingsForAccountValue {\n      performanceByHoldingsForAccountValueId\n      asOfDate\n      accountId\n      accountName\n      marketValue\n      monthToDate\n      quarterToDate\n      yearToDate\n      oneYearReturns\n      threeYearReturns\n      fiveYearReturns\n      tenYearReturns\n      sinceInception\n      inceptionDate\n      householdName\n      productName\n    }\n    getPerformanceByManagementStyle {\n      performanceByManagementStyleId\n      asOfDate\n      managementStyle\n      marketValue\n      monthToDate\n      quarterToDate\n      yearToDate\n      oneYearReturns\n      threeYearReturns\n      fiveYearReturns\n      tenYearReturns\n      sinceInception\n      inceptionDate\n      householdName\n    }\n    getPerformanceByProduct {\n      performanceByProductId\n      householdName\n      productName\n      assetClassName\n      subAssetClassName\n      asOfDate\n      inceptionDate\n      marketValue\n      monthToDate\n      quarterToDate\n      yearToDate\n      oneYearReturns\n      threeYearReturns\n      fiveYearReturns\n      tenYearReturns\n      sinceInception\n    }\n    financialAccounts {\n      id\n      accountName\n      clientIdentifier\n      accountNumber\n      registrationName\n      managementStyle\n      accountType\n      accountTypeAbbreviation\n      custodian\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "babf4619e5e5c3bcffd2257ca4edee3a";

export default node;
